export const siteSettings = {
  name: "Trade4xMarkets",
  link: "https://t4xmarket.org",
  email: "support@t4xmarket.org",
  appLink: "https://app.t4xmarket.org",
};
